export default __webpack_public_path__ + "static/media/calendar.dad83f4b.svg";